import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-6 text-center">
          按分类浏览美剧
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-500 transition-colors">
                <i className={`${cat.icon} text-lg`} />
              </div>
              <span className="text-xs font-medium text-foreground-600 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}